(() => {
  "use strict";

  const SECTION_SELECTOR = "[data-jv-stats]";
  const COUNTER_SELECTOR = "[data-jv-counter]";

  function formatNumber(value, decimals, separator) {
    const fixedValue = Number(value).toFixed(decimals);
    const parts = fixedValue.split(".");

    if (separator === "comma") {
      parts[0] = parts[0].replace(
        /\B(?=(\d{3})+(?!\d))/g,
        ","
      );
    }

    return parts.join(".");
  }

  function animateCounter(counter) {
    if (!counter || counter.dataset.counted === "true") {
      return;
    }

    counter.dataset.counted = "true";

    const start = Number(counter.dataset.start || 0);
    const end = Number(counter.dataset.end || 0);
    const duration = Math.max(
      Number(counter.dataset.duration || 1800),
      100
    );
    const decimals = Math.max(
      Number(counter.dataset.decimals || 0),
      0
    );
    const separator = counter.dataset.separator || "none";

    if (
      window.matchMedia("(prefers-reduced-motion: reduce)")
        .matches
    ) {
      counter.textContent = formatNumber(
        end,
        decimals,
        separator
      );
      return;
    }

    const startTime = performance.now();

    function update(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      const easedProgress =
        1 - Math.pow(1 - progress, 4);

      const currentValue =
        start + (end - start) * easedProgress;

      counter.textContent = formatNumber(
        currentValue,
        decimals,
        separator
      );

      if (progress < 1) {
        window.requestAnimationFrame(update);
      } else {
        counter.textContent = formatNumber(
          end,
          decimals,
          separator
        );
      }
    }

    window.requestAnimationFrame(update);
  }

  function resetCounters(section) {
    section
      .querySelectorAll(COUNTER_SELECTOR)
      .forEach((counter) => {
        counter.dataset.counted = "false";

        const start = Number(counter.dataset.start || 0);
        const decimals = Number(
          counter.dataset.decimals || 0
        );
        const separator =
          counter.dataset.separator || "none";

        counter.textContent = formatNumber(
          start,
          decimals,
          separator
        );
      });
  }

  function initSection(section) {
    if (!section) return;

    resetCounters(section);

    const counters = section.querySelectorAll(
      COUNTER_SELECTOR
    );

    if (!("IntersectionObserver" in window)) {
      counters.forEach(animateCounter);
      return;
    }

    const threshold = Number(
      section.dataset.triggerThreshold || 20
    ) / 100;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          counters.forEach(animateCounter);
          observer.disconnect();
        });
      },
      {
        threshold: threshold
      }
    );

    observer.observe(section);
  }

  function initialize(container = document) {
    container
      .querySelectorAll(SECTION_SELECTOR)
      .forEach((section) => {
        if (section.dataset.jvStatsInitialized === "true") {
          return;
        }

        section.dataset.jvStatsInitialized = "true";
        initSection(section);
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      () => initialize()
    );
  } else {
    initialize();
  }

  document.addEventListener(
    "shopify:section:load",
    (event) => {
      const section = event.target.querySelector(
        SECTION_SELECTOR
      );

      if (section) {
        section.dataset.jvStatsInitialized = "false";
      }

      initialize(event.target);
    }
  );

  document.addEventListener(
    "shopify:block:select",
    (event) => {
      const section = event.target.closest(
        SECTION_SELECTOR
      );

      if (!section) return;

      resetCounters(section);

      section
        .querySelectorAll(COUNTER_SELECTOR)
        .forEach(animateCounter);
    }
  );
})();